import { render, staticRenderFns } from "./VoucherUsers.vue?vue&type=template&id=01fc4738&scoped=true"
import script from "./VoucherUsers.vue?vue&type=script&lang=ts"
export * from "./VoucherUsers.vue?vue&type=script&lang=ts"
import style0 from "./VoucherUsers.vue?vue&type=style&index=0&id=01fc4738&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc4738",
  null
  
)

export default component.exports